import { hasAuthParams, useAuth } from "react-oidc-context";
import { useEffect, useState } from "react";
import { useCurrentUser } from "../lib/hooks/useCurrentUser";
import { useNavigate } from "react-router-dom";
import { useAffiliate } from "../lib/hooks/useAffiliate";
import { Loading } from "../../../common/components/src/components";

export const AuthManager = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  const auth = useAuth();
  const currentUser = useCurrentUser();
  const { setCurrentAffiliate } = useAffiliate();

  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading &&
      !hasTriedSignin
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  // Use this effect to handle redirection based on currentUser
  useEffect(() => {
    if (currentUser && currentUser?.role?.isPending) {
      navigate("/pending");
    }

    if (
      currentUser &&
      currentUser?.role?.dealershipRequired &&
      !currentUser?.role?.dealership
    ) {
      navigate("/pending");
    }
  }, [currentUser]);

  // Set the current affiliate when the user changes
  useEffect(() => {
    if (auth?.user) {
      const storageKey = `api.user.affiliate:${auth?.user?.profile?.sub}`;
      if (auth?.user?.profile?.sub) {
        const storedAffiliate = sessionStorage.getItem(storageKey);
        if (!storedAffiliate) {
          const organization = auth.user.profile.organization;
          const affiliateId = Array.isArray(organization)
            ? [...organization].reverse()[0]
            : organization;
          sessionStorage.setItem(
            `api.user.affiliate:${auth.user.profile.sub}`,
            affiliateId,
          );
          setCurrentAffiliate(affiliateId);
        }
      }
    }
  }, [auth.user]);

  // Check if affiliate is set in sessionStorage
  const isAffiliateSet = auth?.user?.profile?.sub
    ? sessionStorage.getItem(`api.user.affiliate:${auth.user.profile.sub}`) !==
      null
    : false;

  if (auth.isLoading || (auth.isAuthenticated && !isAffiliateSet)) {
    return (
      <div className="flex justify-center items-center h-screen w-screen">
        <Loading />
      </div>
    );
  }

  return children;
};
